import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import IconMenu from '../menu-options/icon';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import { StackOverflowIcon } from '../../components/icons';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Tooltip from '@mui/material/Tooltip';
import { SocialMedia } from '../../constants/links';

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}


function HideOnScroll(props: Props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
    });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
}
export default function HideAppBar(props: Props) {
    return (
        <>
            <HideOnScroll {...props}>
                <AppBar sx={{ background:'#2D2E32',boxShadow:'none'}}>
                    <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
                        <Typography variant="h5" component="h1" sx={{ color: "rgba(255,255,255,90%)",  }}>
                            Abhishek Kumar
                        </Typography>

                        <Box >
                            <Tooltip title="Linked In">
                                <IconButton aria-label='Linked In' size={'small'} sx={{ color: '#fff' }} href={SocialMedia.LINKED_IN} target='_blank'>
                                    <LinkedInIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Github">
                                <IconButton aria-label='Github' size={'small'} sx={{ color: '#fff' }} href={SocialMedia.GITHUB} target='_blank'>
                                    <GitHubIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Stack Overflow">
                                <IconButton aria-label='Stack Overflow' size={'small'} sx={{ color: '#fff' }} href={SocialMedia.STACK_OVERFLOW} target='_blank'>
                                    <StackOverflowIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Contact Me">
                                <IconButton aria-label='contact' size={'small'} color="primary" href={SocialMedia.MAIL_TO}>
                                    <MailOutlineIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Toolbar>

                </AppBar>
            </HideOnScroll>
            
        </>
    );
}